import { useReducer, ReactNode, useEffect, useState, useRef } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { detailsReducer } from './reducers';
import { DetailsStateContext, getDetailsData, getReviewsData, initialValues } from './utils';

export const DetailsProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(detailsReducer, initialValues);
  const { id } = useParams();

  const { data, refetch, isFetching } = useQuery("details", () => getDetailsData(id), {
    refetchOnWindowFocus: false
  });



  useEffect(() => {
    refetch();
    dispatch({
      type: "setActiveTab",
      data: {
        id: 0,
        name: null
      }
    })
    dispatch({
      type: "setParticipationsDetailsUrl",
      data: null
    })
  }, [id])


  const value = {
    ...state,
    data: data || null,
    isDataLoading: isFetching,
    detailsDispatch: dispatch,
  }

  return (
    <DetailsStateContext.Provider value={value}>
      {children}
    </DetailsStateContext.Provider>
  )
}
